import {observer_mgl} from "mobx-graphlink";
import {store} from "../../../../../Store/index.js";
import {observer_mgl_r3} from "../../../../../Utils/ThreeJS/General.js";
import {MapTool, Tool, ToolData} from "./@Tool.js";

export class ToolState_None {
	//constructor() { makeObservable(this); }
}

export class Tool_None extends Tool {
	toolType = MapTool.none;
	get ToolState() { return store.main.maps.tools.toolStates.none; }

	RenderInToolbox = observer_mgl(({data}: {data: ToolData.RenderInToolbox})=>{
		return null;
	});
}